<template>
  <v-card class="pa-2">
    <v-card-title class="subheading font-weight-bold info--text">
      <span>{{ sectionName }} di {{ loggedUserCompany.name }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-actions>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="9"
          class="d-flex align-center"
        >
          <v-row
            class="match-height"
          >
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <generic-info-avatar
                :title="documentsCounterLabel"
                :total="companyDocumentsList.length"
                color="success"
                icon="mdi-file-document"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <generic-info-avatar
                :title="documentFilesCounterLabel"
                :total="totalDocumentFiles"
                color="info"
                icon="mdi-file"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import GenericInfoAvatar from "@/components/avatars/generic-info-avatar.vue";

export default {
  name: 'CompanyCard',
  components: {GenericInfoAvatar},
  props: {
    sectionName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['loggedUserCompany', 'companyDocumentsList', 'partnerSettings']),
    documentsCounterLabel() {
      return this.partnerSettings?.dictionary?.main?.[this.companyDocumentsList.length === 1 ? 'document' : 'documents'] ?? (this.companyDocumentsList.length === 1 ? 'Documento' : 'Documenti')
    },
    documentFilesCounterLabel() {
      return this.partnerSettings?.dictionary?.main?.[this.companyDocumentsList.files_count === 1 ? 'file' : 'files'] ?? (this.companyDocumentsList.files_count === 1 ? 'File' : 'Files')
    },
    totalDocumentFiles() {
      return this.companyDocumentsList.reduce((acc, doc) => acc + doc.files_count, 0)
    },
  },
}

</script>
